import 'init';

import $ from 'jquery';
import * as singleSpa from 'single-spa';

import * as GammaApp from 'singlespa/apps/gamma';
import * as ClassicApp from 'singlespa/apps/classic';
import Interceptor from 'singlespa/interceptor';

// This is a "loading function" Inside of it, the import introduces a code splitting
// point — Webpack will create separate code chunks that will be lazy loaded by single-spa.
const loadGamma = () => Promise.resolve().then(() => GammaApp);
const loadClassic = () => Promise.resolve().then(() => ClassicApp);

// This is an "activity function"
// this is where we'd check for whether this is a classic or gamma url ... rather than use window location
const isGammaActive = () => Interceptor.isGammaRoute(window.location.pathname)
const isClassicActive = () => !isGammaActive()

// Register the application with single-spa
singleSpa.declareChildApplication('gamma', loadGamma, isGammaActive);
singleSpa.declareChildApplication('classic', loadClassic, isClassicActive);

// Tell single-spa that you're ready for it to mount your application to the DOM
$(() => {
  ClassicApp.setElem(document.getElementById('classic'));
  singleSpa.start()
})



// WEBPACK FOOTER //
// ./app/scripts/entry/app.js